import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { Image } from '@thd-olt-component-react/core-ui';
import styles from './article-info-pod.module.scss';

const ArticleInfoPod = ({ title, articleDetails }) => {

  const iconUrl = 'check.svg';
  const cx = classNames.bind(styles);

  return (
    <div className={cx('article-infopod-container')}>
      <div className={cx('article-infopod-container__heading')}>
        <Image
          className={cx('article-infopod-container__check-icon')}
          asset={iconUrl}
          alt="check"
          width="10"
        />
        <span>{title}</span>
      </div>
      <div className={cx('article-details')}>
        {articleDetails}
      </div>
    </div>
  );
};

ArticleInfoPod.defaultProps = {
  title: '',
  articleDetails: ''
};
ArticleInfoPod.propTypes = {
  title: string,
  articleDetails: string,
};
export { ArticleInfoPod };
